import { PriceProps } from './types';

export const Price = ({ amount, noCurrency, className }: PriceProps): JSX.Element => {
  const formatted = new Intl.NumberFormat('ru-RU').format(amount);

  return (
    <>
      <span className={className}>{formatted}</span>
      {!noCurrency && <span className="currency"> ₽</span>}
    </>
  );
};
